"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataValue = exports.Column = exports.MarkInfo = exports.DataTable = void 0;
class DataTable {
    constructor(_data, _columns, _totalRowCount, _isTotalRowCountLimited, _isSummaryData, _marksInfo) {
        this._data = _data;
        this._columns = _columns;
        this._totalRowCount = _totalRowCount;
        this._isTotalRowCountLimited = _isTotalRowCountLimited;
        this._isSummaryData = _isSummaryData;
        this._marksInfo = _marksInfo;
        this._name = _isSummaryData ? 'Summary Data Table' : 'Underlying Data Table';
    }
    get name() {
        return this._name;
    }
    get data() {
        return this._data;
    }
    get columns() {
        return this._columns;
    }
    get marksInfo() {
        return this._marksInfo;
    }
    get totalRowCount() {
        return this._totalRowCount;
    }
    get isTotalRowCountLimited() {
        return this._isTotalRowCountLimited;
    }
    get isSummaryData() {
        return this._isSummaryData;
    }
}
exports.DataTable = DataTable;
class MarkInfo {
    constructor(_type, _color, _tupleId) {
        this._type = _type;
        this._color = _color;
        this._tupleId = _tupleId;
    }
    get type() {
        return this._type;
    }
    get color() {
        return this._color;
    }
    get tupleId() {
        return this._tupleId;
    }
}
exports.MarkInfo = MarkInfo;
class Column {
    constructor(_fieldName, _fieldId, _dataType, _isReferenced, _index) {
        this._fieldName = _fieldName;
        this._fieldId = _fieldId;
        this._dataType = _dataType;
        this._isReferenced = _isReferenced;
        this._index = _index;
    }
    get fieldName() {
        return this._fieldName;
    }
    get fieldId() {
        return this._fieldId;
    }
    get dataType() {
        return this._dataType;
    }
    get isReferenced() {
        return this._isReferenced;
    }
    get index() {
        return this._index;
    }
}
exports.Column = Column;
class DataValue {
    /* tslint:disable:no-any */
    constructor(_value, _nativeValue, _formattedValue, _aliasValue, _hasAlias) {
        this._value = _value;
        this._nativeValue = _nativeValue;
        this._formattedValue = _formattedValue;
        this._aliasValue = _aliasValue;
        this._hasAlias = _hasAlias;
    }
    get value() {
        return this._value;
    }
    get nativeValue() {
        return this._nativeValue;
    }
    get formattedValue() {
        return this._formattedValue;
    }
    get aliasValue() {
        return this._aliasValue;
    }
    get hasAlias() {
        return this._hasAlias;
    }
}
exports.DataValue = DataValue;
//# sourceMappingURL=GetDataModels.js.map